import { render, staticRenderFns } from "./MessageTemplates.vue?vue&type=template&id=6212d1dc&scoped=true&"
import script from "./MessageTemplates.vue?vue&type=script&lang=js&"
export * from "./MessageTemplates.vue?vue&type=script&lang=js&"
import style0 from "./MessageTemplates.vue?vue&type=style&index=0&id=6212d1dc&prod&lang=scss&scoped=true&"
import style1 from "./MessageTemplates.vue?vue&type=style&index=1&id=6212d1dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6212d1dc",
  null
  
)

export default component.exports